import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosHandler from "./axiosHandler";

export const getAllDesignation = createAsyncThunk(
    "designation/getAllDesignation",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axiosHandler.get(`/designation/getAllDesignation`);
        return response?.data?.data;
      } catch (error) {
        return throwError(error,rejectWithValue)
      }
    }
  );
  
  export const createDesignation = createAsyncThunk(
    "designation/create",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosHandler.post(`designation/create`, data);
        return response.data?.data;
      } catch (error) {
        return throwError(error,rejectWithValue)
      }
    }
  );
  
  export const deleteDesignation = createAsyncThunk(
    "designation/delete",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosHandler.delete(
          `/designation/deleteDesignation/${id}`
        );
        if (response && response?.data?.status === "200") {
          return id;
        } else return null;
      } catch (error) {
        return throwError(error,rejectWithValue)
      }
    }
  );
  
  export const updateDesignation = createAsyncThunk(
    "designation/update",
    async ({ id, data }, { rejectWithValue }) => {
      try {
        const response = await axiosHandler.post(
          `/designation/updateDesignation/${id}`,
          data
        );
        return response?.data?.data;
      } catch (error) {
        return throwError(error,rejectWithValue)
      }
    }
  );

  const throwError=(error,rejectWithValue)=>{
    return rejectWithValue(
         error?.response?.data || "An error occurred"
      );
  }